import * as React from "react";
import { PensionBase } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/PensionBase";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { PensionProtection as PensionProtectionButton } from "../../PaymentsIn/SIPP/PensionProtection";
import { SectionHeader } from "../../SharedComponents";
import { PensionProtectionPlayBack } from "./PensionProtectionPlayBack";

interface IPensionProtectionProps extends IProcessComponentProps {
    data: PensionBase;
    process: ProcessType;
}

interface IPensionProtectionState {
    hasChanged: boolean;
}

export class PensionProtection extends ProcessComponent<IPensionProtectionProps, IPensionProtectionState> {
    constructor(props: any) {
        super(props);
        this.state = {
            hasChanged: false,
        };
    }

    public render(): JSX.Element {
        const { data, onChange, process } = this.props;

        return (
            <>
                {SectionHeader("Pension protection")}
                {![ProcessType.NB, ProcessType.Quote, ProcessType.TopUpWithITFLS].includes(process) ? (
                    <>
                        <p>
                            If your client has any form of pension protection which they are using for this withdrawal,
                            please click below to add the details
                        </p>
                        <PensionProtectionButton
                            data={data}
                            label={data?.HasPensionProtection ? "Edit pension protection" : "Add pension protection"}
                            onChange={(v) => onChange(v)}
                            onRef={(ref) => this.appendChild(ref)}
                        />
                    </>
                ) : (
                    <PensionProtectionPlayBack
                        data={data?.PensionProtection}
                        hasPensionProtection={data?.HasPensionProtection}
                    />
                )}
            </>
        );
    }
}
